//libs
import React, { useRef, useState } from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';

import useRect from '@lyearn/core/hooks/useRect';
import { useForkRef } from '@lyearn/ui';

//hooks
import useCalculatedWidth from './hooks/useCalculatedWidth';
//components
import Caption from './Caption';
import { NODE_CONTAINER_CLASSNAME } from './consts';
import HotspotContainer from './Hotspot';
import Resizehandle from './Resizehandle';
//styles
import { allTransition, nodeContainerWidth } from './style';
//types
import { ResizeContainerProps } from './types';

const ResizeContainer: React.FC<ResizeContainerProps> = (props) => {
  const {
    nodeRef,
    readOnly,
    children,
    caption,
    width,
    maxHeight,
    canChangeHeight,
    hotspots,
    hotspotsEnabled,
    captionEnabled = true,
    className,
    disableResizing,
    isMicroLearning,
  } = props;

  const [nodeHover, setNodeHover] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);
  const { ref: nodeContainerRef, width: nodeWidth, height } = useRect<HTMLDivElement>();

  const ref = useForkRef(nodeContainerRef, divRef);
  const calculatedWidth = useCalculatedWidth(width);
  const isFullWidth = width === 100;

  return (
    <div>
      <div
        ref={ref}
        className={c(
          isMicroLearning
            ? 'relative mt-24 flex  w-full  xs:start-0'
            : 'relative mt-32 mb-16 flex end-1/2 start-1/2 xs:start-0',
          isMicroLearning ? '' : nodeContainerWidth(calculatedWidth),
          allTransition,
          NODE_CONTAINER_CLASSNAME,
          className || 'justify-center',
        )}>
        <div className="relative xs:w-full">
          {hotspotsEnabled ? (
            <HotspotContainer
              height={height}
              hotspots={hotspots}
              nodeElement={divRef.current!}
              readOnly={readOnly}
              width={nodeWidth}
            />
          ) : null}
          {disableResizing ? null : (
            <Resizehandle
              maxHeight={maxHeight}
              nodeContainer={divRef.current!}
              nodeHover={nodeHover}
              nodeRef={nodeRef}
              readOnly={readOnly}
              setNodeHover={setNodeHover}
              showHeightHandler={isFullWidth && !!canChangeHeight}
            />
          )}
          {isFunction(children) ? children({ calculatedWidth }) : children}
        </div>
      </div>
      {captionEnabled ? <Caption caption={caption} readOnly={readOnly} /> : null}
    </div>
  );
};

export default ResizeContainer;
